import * as $ from "jquery";
import "jquery-ui/ui/position";
import "jquery-ui/ui/widgets/draggable";
import "jquery-ui/ui/widgets/droppable";
import "jquery-ui/ui/widgets/sortable";
import "virtual-keyboard";

window.jQuery = window.$ = $;
